import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { formatDateBr } from '@core/utils/filter';
import SLSWorkflowUsuarioService from '@/services/SistemaDKP/Workflow/SISWorkflowUsuario.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useUsersList(nameModule) {
  // Use toast
  const toast = useToast();
  const sLSWorkflowUsuarioService = new SLSWorkflowUsuarioService();
  const refWorkflowUsuarioListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    // {key: 'workflowid', label: 'Codigo', sortable: false},
    { key: 'Funcionario.usuario_nome', label: 'Funcionario', sortable: true },
    { key: 'Workflow.workflowdescricao', label: 'WorkFlow', sortable: true },
    { key: 'actions', label: 'Ações', sortable: false },
  ];
  const perPage = ref(10);
  const totalWorkflowUsuario = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('workflowid');
  const isSortDirDesc = ref(false);
  const overlay = ref(true);
  const statusFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refWorkflowUsuarioListTable.value ? refWorkflowUsuarioListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalWorkflowUsuario.value,
    };
  });

  const refetchData = () => {
    refWorkflowUsuarioListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData();
  });

  const fetchWorkflowUsuario = (ctx, callback) => {
    sLSWorkflowUsuarioService.index({
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      fullObject: true,
    }).then((response) => {
      const { data, total } = response;
      overlay.value = false;
      // console.log(data);
      callback(data);
      perPage.value = response.perPage;
      currentPage.value = response.page;
      totalWorkflowUsuario.value = total;
    })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      });
  };

  const create = async (body) => {
    try {
      await sLSWorkflowUsuarioService.store(body);
      toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Workflow cadastrado com sucesso!',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
      refetchData();
    } catch (error) {
      console.error('Erro ao cadastrar Workflow.');
      toast({
        component: ToastificationContent,
        props: {
          title: 'Erro',
          text: 'Erro ao cadastrar Workflow.',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      });
    }
  };
  const Updated = async (body) => {
    try {
      await sLSWorkflowUsuarioService.update(body);
      toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Workflow atualizado com sucesso!',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
      refetchData();
    } catch (error) {
      console.error('Erro ao cadastrar Workflow.');
      toast({
        component: ToastificationContent,
        props: {
          title: 'Erro',
          text: 'Erro ao atualizar Workflow.',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      });
    }
  };

  const removerData = async (body) => {
    await sLSWorkflowUsuarioService.destroy(body);
    refetchData();
  };

  const resolveTypeFieldText = type => {
    if (type === 'VARCHAR') return 'Texto';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'Data';
    if (type === 'DATETIME') return 'Data e Hora';
    if (type === 'DECIMAL') return 'Monetário';
    if (type === 'TEXT') return 'Texto Longo';
    if (type === 'INTEGER' || type === 'INT') return 'Númerico';
    return 'Sem Tipo';
  };
  const resolveTypeFieldIcon = type => {
    if (type === 'VARCHAR') return 'tabler:abc';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'system-uicons:calendar-date';
    if (type === 'DATETIME') return 'formkit:datetime';
    if (type === 'TEXT') return 'mdi:text-long';
    if (type === 'DECIMAL') return 'tabler:decimal';
    if (type === 'DECIMAL' || type === 'INTEGER' || type === 'INT') return 'tabler:123';
    return 'nonicons:type-16';
  };

  const resolveItemStatusVariant = (status) => {
    if (status === 'PENDING') return 'light-warning';
    if (status === 'ATIVO') return 'light-success';
    if (status === 'INATIVO') return 'light-danger';
    return 'primary';
  };

  return {
    fetchWorkflowUsuario,
    tableColumns,
    perPage,
    currentPage,
    totalWorkflowUsuario,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refWorkflowUsuarioListTable,
    overlay,
    resolveTypeFieldText,
    resolveTypeFieldIcon,
    resolveItemStatusVariant,
    refetchData,
    create,
    Updated,

    // Extra Filters
    statusFilter,
    removerData,
  };
}
